import React from 'react'

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 bg-purgatory-dark bg-opacity-90 flex items-center justify-center z-50">
      <div className="text-center">
        {/* Loading spinner */}
        <div className="relative w-20 h-20 mx-auto mb-8">
          <div className="absolute inset-0 border-4 border-purgatory-ash rounded-full"></div>
          <div className="absolute inset-0 border-4 border-transparent border-t-neon-green rounded-full animate-spin"></div>
        </div>
        
        {/* Loading text */}
        <div className="space-y-2">
          <h2 className="text-2xl font-bold text-neon-green animate-pulse">
            Descending into Purgatory...
          </h2>
          <p className="text-purgatory-mist font-mono text-sm">
            Preparing your journey through the levels
          </p>
        </div>
        
        {/* Loading dots */}
        <div className="flex justify-center space-x-2 mt-6">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="w-2 h-2 bg-purgatory-gold rounded-full animate-pulse"
              style={{
                animationDelay: `${i * 0.2}s`,
                animationDuration: '1s',
              }}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default LoadingScreen
